interface ITutorial {
  title: string;
  text: string;
  videoUrl?: string;
  pdfUrl?: string;
}

export const tutorialsData: ITutorial[] = [
  {
    title: 'Creación de orden en un punto99',
    text: 'Aprende a crear una orden con punto99.',
    videoUrl:
      'https://self-service-videos.s3.us-east-2.amazonaws.com/Creaci%C3%B3n+de+orden+en+un+punto99.mp4',
  },
  {
    title: 'Creación de orden a domicilio',
    text: 'Aprende a crear una orden a domicilio.',
    videoUrl:
      'https://self-service-videos.s3.us-east-2.amazonaws.com/Creacio%CC%81n+de+orden_A+domicilio.mp4',
  },
  {
    title: 'Carga masiva',
    text: '¿Necesitas cargar varias órdenes a la vez? Ve el video tutorial',
    videoUrl: 'https://self-service-videos.s3.us-east-2.amazonaws.com/CARGA_MASIVA_V4_DEMO.mp4.mp4',
  },
  {
    title: 'Cobertura',
    text: '¿Tienes dudas sobre como verificar una cobertura? Te enseñamos como hacerlo.',
    videoUrl: 'https://self-service-videos.s3.us-east-2.amazonaws.com/cobertura.webm',
  },
  {
    title: 'Rastreo de envíos',
    text: 'Aprende a llevar el control de tus órdenes en todo momento.',
    videoUrl: 'https://self-service-videos.s3.us-east-2.amazonaws.com/rastreo.webm',
  },
  {
    title: 'Órdenes e historias',
    text: 'Conoce la manera en la que puedes obtener información de todas tus órdenes, aún finalizadas.',
    videoUrl: 'https://self-service-videos.s3.us-east-2.amazonaws.com/ordenes_e_historias.webm',
  },
  {
    title: 'Recarga de saldo',
    text: '¿Te quedaste sin saldo? Sigue estos pasos de forma rápida y fácil.',
    videoUrl: 'https://self-service-videos.s3.us-east-2.amazonaws.com/recargar_saldo.webm',
  },
  {
    title: 'Subcuentas',
    text: 'Aprende a crear cuentas a otros usuarios que colaboran contigo.',
    videoUrl: 'https://self-service-videos.s3.us-east-2.amazonaws.com/subcuentas.webm',
  },
];
export const tutorialsDataChile: ITutorial[] = [
  {
    title: 'Guía de Embalaje',
    text: 'Recomendaciones para un embalaje seguro y eficiente',
    pdfUrl:
      'https://storage.googleapis.com/hub99-public-docs/documentation/99minutos%20Chile%20-%20Gu%C3%ADa%20de%20embalaje.pdf', // aca va el pdf
  },
  {
    title: 'Creación de orden a domicilio',
    text: 'Aprende a crear una orden a domicilio.',
    videoUrl:
      'https://self-service-videos.s3.us-east-2.amazonaws.com/Creacio%CC%81n+de+orden_A+domicilio.mp4',
  },
  {
    title: 'Carga masiva',
    text: '¿Necesitas cargar varias órdenes a la vez? Ve el video tutorial',
    videoUrl: 'https://self-service-videos.s3.us-east-2.amazonaws.com/CARGA_MASIVA_V4_DEMO.mp4.mp4',
  },
  {
    title: 'Cobertura',
    text: '¿Tienes dudas sobre como verificar una cobertura? Te enseñamos como hacerlo.',
    videoUrl: 'https://self-service-videos.s3.us-east-2.amazonaws.com/cobertura.webm',
  },
  {
    title: 'Rastreo de envíos',
    text: 'Aprende a llevar el control de tus órdenes en todo momento.',
    videoUrl: 'https://self-service-videos.s3.us-east-2.amazonaws.com/rastreo.webm',
  },
  {
    title: 'Órdenes e historias',
    text: 'Conoce la manera en la que puedes obtener información de todas tus órdenes, aún finalizadas.',
    videoUrl: 'https://self-service-videos.s3.us-east-2.amazonaws.com/ordenes_e_historias.webm',
  },
  {
    title: 'Recarga de saldo',
    text: '¿Te quedaste sin saldo? Sigue estos pasos de forma rápida y fácil.',
    videoUrl: 'https://self-service-videos.s3.us-east-2.amazonaws.com/recargar_saldo.webm',
  },
  {
    title: 'Subcuentas',
    text: 'Aprende a crear cuentas a otros usuarios que colaboran contigo.',
    videoUrl: 'https://self-service-videos.s3.us-east-2.amazonaws.com/subcuentas.webm',
  },
];
